import EdoProgramRequestDetail from './EdoProgramRequestDetail';

export default EdoProgramRequestDetail;
